import useStateStore from 'services/store';
import './name-size.scss';

const NameSize = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('name-size', id);
  };
  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">NAME YOUR SIZE</div>
        <div className="confirm">
          Naming a size is a piece of cake and totally up to you, so feel free
          to have fun with it! The name of the size is printed on the washing
          advice in your garment.
        </div>
      </div>
      <div className="name-size">
        <label className="label-name">Name</label>
        <input
          onChange={(e) => handleChangeSteps(e.target.value)}
          value={steps['name-size']}
          type="text"
          className="input-name-size"
        />
      </div>
    </div>
  );
};

export default NameSize;
